import {
  useDynamicComponentDomStateStore,
} from "%/dynamic-component-editor/stores/dynamic-component-dom-state-store";
import DynamicComponentError from "%/dynamic-component-editor/errors/dynamic-component-error";

const VIEWPORT_BREAKPOINT_IDENTIFIER = "default";

const DomStateMixinProduction = {
  inject: {
    dceFrameKey: {
      from: "dceFrameKey",
      default: null,
    },
  },
  data: () => ({
    productionPointEnter: false,
    parentEl: null,
    parentElIdentifier: "default",
  }),
  computed: {
    activeState() {
      let activeState = "default";

      if (this.productionPointEnter) {
        activeState = "hover";
      }

      if (this.dceFrameKey !== null) {
        if (this.dceFrameKey && this.dceFrameKey !== "default") {
          return `${activeState}:${this.dceFrameKey}`;
        }
        return activeState;
      }

      const breakpointAlias = useDynamicComponentDomStateStore().activeBreakpoints[this.parentElIdentifier];
      if (breakpointAlias) {
        activeState += `:${breakpointAlias}`;
      }

      return activeState;
    },
  },
  mounted() {
    this.initParentEl();
    this.initBreakpointListener();
  },
  methods: {
    initParentEl() {
      if (this.parentEl) {
        return;
      }
      this.parentEl = this.findParentOfRootLayout(this.$el);
      if (this.parentEl) {
        const breakpointId = this.parentEl.dataset.breakpointId;
        if (breakpointId) {
          this.parentElIdentifier = breakpointId;
        }
      }
    },
    initBreakpointListener() {
      if (this.editMode || this.dceFrameKey !== null) {
        return;
      }
      if (!this.parentEl && this.parentElIdentifier !== VIEWPORT_BREAKPOINT_IDENTIFIER) {
        throw new DynamicComponentError(
          "breakpoint identifier came from a frame element that is no longer in the DOM — the "
            + "element-bound observer has nothing to measure",
          { identifier: this.parentElIdentifier },
        );
      }
      useDynamicComponentDomStateStore().setBreakpointListener(this.parentEl, this.parentElIdentifier);
    },
    findParentOfRootLayout(element) {
      const isRootLayout = node => {
        if (!node) {
          return false;
        }
        if (node.id === "root-layout") {
          return true;
        }
        if (typeof node.classList?.contains !== "function") {
          return false;
        }
        return node.classList.contains("root-layout");
      };
      let current = element;

      if (!current) {
        return null;
      }

      if (isRootLayout(current)) {
        return current.parentElement;
      }

      while (current.parentElement) {
        current = current.parentElement;

        if (isRootLayout(current)) {
          return current.parentElement;
        }
      }

      return null;
    },
    addPointOver() {
      this.productionPointEnter = true;
    },
    removePointOver() {
      this.productionPointEnter = false;
    },
  },
};

export default DomStateMixinProduction;
